import React from "react";
import ReactPlayer from "react-player";

class Propaganda extends React.Component {
  render() {
    return (
      <div className="propaganda">
        <ReactPlayer
          url={"https://www.youtube.com/watch?v=E9Dv-oOtzDQ"}
          config={{
            youtube: {
              playerVars: { showinfo: 1 },
            },
          }}
        />
        <p>curated propaganda.</p>
      </div>
    );
  }
}

export default Propaganda;
